export enum SponsorBenefitType {
    MONTHLY = 'MONTHLY',
    DAILY = 'DAILY',
}